import ILearnMoreUpdated from "@interfaces/Clients/Hackatao/learnMore/learnMoreUpdated";

const learnMoreMapper = (formValues: any): ILearnMoreUpdated => ({
  title: formValues.title,
  bodyText: formValues.bodyText,
});

export default learnMoreMapper;
